import { MENU_DISCOUNT_BADGE_LABEL, MenuItem } from '@constants/navi';
import { KTSVG } from '@helpers/index';
import { getHasUpsellDiscountSelector } from '@modules/shop/core/selectors';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

interface NavigationItemProps {
  item: MenuItem;
  isActive: boolean;
  onClick: () => void;
}

export const MenuMobileItem = forwardRef<HTMLDivElement, NavigationItemProps>(
  ({ item, isActive, onClick }, ref) => {
    const intl = useIntl();
    const hasUpsellDiscount = useSelector(getHasUpsellDiscountSelector);
    const iconName: string = isActive && item.iconActive ? item.iconActive : item.icon;

    // Same three conditions as the sidebar badge: the entry opts in, a discount is
    // actually live in the upsell feed, and this is not the page we are already on.
    const showDiscountBadge = item.hasDiscountIcon && hasUpsellDiscount && !isActive;

    const handleClick = (): void => {
      onClick();
    };

    return (
      <div ref={ref} className={`mobile-menu-list-item ${isActive ? 'active' : ''}`}>
        <Link to={item.to} onClick={handleClick}>
          <span className={clsx('icon')}>
            <KTSVG path={iconName} className="svg-icon-2" />
          </span>
          <span className="text">{intl.formatMessage({ id: item.title })}</span>
          {/* Left in the accessibility tree when shown: the link reads as
              "Mitbestellen -20%", and hiding it would drop the only cue that the
              tab is on offer. */}
          {showDiscountBadge && (
            <span className="mobile-menu-list-item-badge">{MENU_DISCOUNT_BADGE_LABEL}</span>
          )}
        </Link>
      </div>
    );
  },
);

MenuMobileItem.displayName = 'MenuMobileItem';

export default MenuMobileItem;
